import { getContext } from '@fiverr-private/fiverr_context';

export const getSearchTitleData = (searchTitleData) => {
    const { queryParameters: { query } = {} } = getContext();
    const { translatedQuery, modifiedQueryString, nonTranslatedQuery } = searchTitleData;
    const displayQuery = modifiedQueryString || translatedQuery || query;

    return { displayQuery, modifiedQueryString, nonTranslatedQuery, translatedQuery, query };
};
